function skioGroupTypographyFor(picker) {
    const cls = picker.closest("section[id]")?.className || "";
    if (cls.includes("productV1--quiz")) {
        return {
            titleFamily: "Figtree, sans-serif", titleSize: 16, titleWeight: 600,
            bulletsFamily: "Figtree, sans-serif", bulletsSize: 14, bulletsColor: "#383838",
            freqFamily: "Figtree, sans-serif", freqSize: 14, freqColor: "#383838",
        };
    }
    if (cls.includes("ProtectRedesignV2")) {
        return {
            titleFamily: "Figtree, sans-serif", titleSize: 16, titleWeight: 600,
            bulletsFamily: "Figtree, sans-serif", bulletsSize: 13, bulletsColor: "#383838",
            freqFamily: "Figtree, sans-serif", freqSize: 13, freqColor: "#383838",
        };
    }
    if (cls.includes("ProtectRedesignV1")) {
        return {
            titleFamily: "Figtree, sans-serif", titleSize: 14, titleWeight: 600,
            bulletsFamily: "Figtree, sans-serif", bulletsSize: 12, bulletsColor: "#383838",
        };
    }
    return {
        titleFamily: "Figtree, sans-serif", titleSize: 16, titleWeight: 400,
        bulletsFamily: "Graphik, sans-serif", bulletsSize: 11, bulletsColor: "#4d5264",
    };
}

(function () {
    if (window.__skioDiscountPatchApplied) return;
    window.__skioDiscountPatchApplied = true;

    customElements.whenDefined("skio-plan-picker").then(function () {
        const proto = customElements.get("skio-plan-picker").prototype;
        const original = proto.getDiscountFromPriceAdjustment;
        proto.getDiscountFromPriceAdjustment = function (selling_plan, price_adjustment) {
            if (!price_adjustment) {
                return {percent: 0, amount: 0, absolute: 0};
            }
            return original.call(this, selling_plan, price_adjustment);
        };
    });
})();

(function () {
    if (window.__skioUpdateSellingPlanSyncApplied) return;
    window.__skioUpdateSellingPlanSyncApplied = true;

    function skioBottlesForPlanName(name) {
        const lower = (name || "").toLowerCase();
        if (lower.includes("6-month") || lower.includes("6 month")) return 6;
        if (lower.includes("3-month") || lower.includes("3 month")) return 3;
        return 1;
    }

    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        const section = picker.closest("section[id]");
        const subToggle = section?.querySelector('.productV1SellingLabelInput[value="sub"]');
        if (!subToggle) return;

        const sellingPlan = event.detail?.sellingPlan;
        if (!sellingPlan) return;

        subToggle.dataset.plan = sellingPlan.id;

        const bottles = skioBottlesForPlanName(sellingPlan.name);
        subToggle.dataset.quantity = bottles;

        const variant = event.detail?.variant;
        const allocation = variant?.selling_plan_allocations?.find(a => a.selling_plan_id === sellingPlan.id);
        if (allocation) {
            subToggle.dataset.price = allocation.price * bottles;
        }
    });
})();

(function () {
    if (window.__skioSubscribeClickApplied) return;
    window.__skioSubscribeClickApplied = true;

    document.addEventListener("click", function (event) {
        const picker = event.target.closest && event.target.closest("skio-plan-picker");
        if (!picker) return;

        const path = typeof event.composedPath === "function" ? event.composedPath() : [];
        if (path.some(function (el) { return el.classList?.contains("selling-plan-dropdown"); })) return;

        const section = picker.closest("section[id]");
        const subToggle = section?.querySelector('.productV1SellingLabelInput[value="sub"]');
        if (subToggle && !subToggle.checked) {
            subToggle.checked = true;
            subToggle.dispatchEvent(new Event("change", {bubbles: true}));
        }
    });

    document.addEventListener("change", function (event) {
        const otpToggle = event.target;
        if (!otpToggle.matches || !otpToggle.matches('.productV1SellingLabelInput[value="otp"]')) return;
        if (!otpToggle.checked) return;

        const section = otpToggle.closest("section[id]");
        const picker = section?.querySelector("skio-plan-picker");
        if (picker && typeof picker.selectSellingPlanGroup === "function") {
            picker.selectSellingPlanGroup(null);

            picker.shadowRoot?.querySelectorAll("input.group-input").forEach(function (radio) {
                radio.checked = false;
            });
        }
    });
})();

(function () {
    if (window.__skioDropdownChangeSyncApplied) return;
    window.__skioDropdownChangeSyncApplied = true;

    const wired = new WeakSet();
    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        if (wired.has(picker) || !picker.shadowRoot) return;
        wired.add(picker);

        picker.shadowRoot.addEventListener("change", function (changeEvent) {
            if (!changeEvent.target.matches || !changeEvent.target.matches("select.selling-plan-dropdown")) return;

            const section = picker.closest("section[id]");
            const subToggle = section?.querySelector('.productV1SellingLabelInput[value="sub"]');
            if (subToggle && !subToggle.checked) {
                subToggle.checked = true;
                subToggle.dispatchEvent(new Event("change", {bubbles: true}));
            }
        });
    });
})();

(function () {
    if (window.__skioSubscriptionBulletsApplied) return;
    window.__skioSubscriptionBulletsApplied = true;

    const reconciled = new WeakSet();
    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        if (reconciled.has(picker)) return;
        reconciled.add(picker);

        const bullets = picker.dataset.subscriptionBullets;
        if (!bullets) return;

        const existing = picker.options?.additional_subscription_content || "";
        picker.options = {...picker.options, additional_subscription_content: bullets + existing};
    });
})();

(function () {
    if (window.__skioStackPriceApplied) return;
    window.__skioStackPriceApplied = true;

    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        if (!picker.options?.stack_price_under_title || !picker.shadowRoot) return;

        picker.shadowRoot.querySelectorAll(".group-topline").forEach(function (topline) {
            const price = topline.querySelector(".skio-price");
            const title = topline.querySelector(".group-title");
            if (!price || !title) return;

            const radio = topline.querySelector(".skio-radio__container");
            const perServingNeeded = !!picker.options?.show_per_serving_price;

            const columns = [];
            if (radio) columns.push("auto");
            columns.push("1fr");
            if (perServingNeeded) columns.push("auto");

            topline.style.display = "grid";
            topline.style.gridTemplateColumns = columns.join(" ");
            topline.style.alignItems = "start";
            topline.style.columnGap = "8px";
            topline.style.rowGap = "0";

            const mainColStart = radio ? 2 : 1;

            if (radio) {
                radio.style.gridColumn = "1";
                radio.style.gridRow = "1";
                radio.style.alignSelf = "start";
            }

            title.style.gridColumn = mainColStart + " / -1";
            title.style.gridRow = "1";

            price.style.marginLeft = "0";
            price.style.justifyContent = "flex-start";
            price.style.textAlign = "left";
            price.style.gridRow = "2";

            if (perServingNeeded) {
                price.style.gridColumn = "1 / -2";
                price.style.marginTop = "8px";
                price.style.marginBottom = "0";

                let perServing = topline.querySelector(":scope > .skioPerServing");
                if (!perServing) {
                    perServing = document.createElement("span");
                    perServing.className = "skioPerServing";
                    perServing.style.fontFamily = "Figtree, sans-serif";
                    perServing.style.fontSize = "12px";
                    perServing.style.fontWeight = "600";
                    perServing.style.lineHeight = "17px";
                    perServing.style.textTransform = "uppercase";
                    perServing.style.whiteSpace = "nowrap";
                    topline.appendChild(perServing);
                }
                perServing.style.color = picker.options?.group_text_color || "inherit";
                perServing.style.gridColumn = "-2 / -1";
                perServing.style.gridRow = "2";
                perServing.style.alignSelf = "end";
                perServing.style.justifySelf = "end";

                let divider = topline.querySelector(":scope > .skioPriceDivider");
                if (!divider) {
                    divider = document.createElement("div");
                    divider.className = "skioPriceDivider";
                    topline.appendChild(divider);
                }
                divider.style.gridColumn = "1 / -1";
                divider.style.gridRow = "3";
                divider.style.paddingBottom = "20px";
                divider.style.borderBottom = "1px solid rgba(84,93,255,.2)";
                divider.style.marginBottom = "4px";
            } else if (picker.options?.show_bottle_billing_text) {
                price.style.gridColumn = "1 / -1";
                price.style.marginTop = "8px";
                price.style.marginBottom = "6px";
            } else {
                price.style.gridColumn = "1 / -1";
                price.style.marginTop = "8px";
                price.style.marginBottom = "4px";
                price.style.paddingBottom = "20px";
                price.style.borderBottom = "1px solid rgba(84,93,255,.2)";
            }
        });
    });
})();

(function () {
    if (window.__skioPerServingApplied) return;
    window.__skioPerServingApplied = true;

    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        if (!picker.shadowRoot || !picker.options?.show_per_serving_price) return;
        if (!picker.selectedSellingPlan) return;

        const servings = Number(picker.options?.servings_count) || 12;
        const rawPrice = picker.price(picker.selectedSellingPlan, false);
        const perServingText = picker.money(rawPrice / servings);

        picker.shadowRoot.querySelectorAll(".skioPerServing").forEach(function (el) {
            el.textContent = `${perServingText} per serving`;
        });
    });
})();

(function () {
    if (window.__skioPriceNoTrailingZerosApplied) return;
    window.__skioPriceNoTrailingZerosApplied = true;

    function stripTrailingCents(root) {
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
            if (/\.00(?=\D|$)/.test(node.nodeValue)) {
                node.nodeValue = node.nodeValue.replace(/\.00(?=\D|$)/, "");
            }
        }
    }

    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        if (!picker.shadowRoot) return;
        picker.shadowRoot.querySelectorAll(".skio-price").forEach(stripTrailingCents);
    });
})();

(function () {
    if (window.__skioPriceMonthlySuffixApplied) return;
    window.__skioPriceMonthlySuffixApplied = true;

    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        if (!picker.shadowRoot || !picker.options?.show_bottle_billing_text) return;

        picker.shadowRoot.querySelectorAll(".skio-price").forEach(function (priceEl) {
            let suffix = priceEl.querySelector(":scope > .skio-price-mo");
            if (!suffix) {
                suffix = document.createElement("span");
                suffix.className = "skio-price-mo";
                suffix.style.fontSize = "14px";
                suffix.style.fontWeight = "600";
                priceEl.appendChild(suffix);
            }
            suffix.textContent = "/mo";
        });
    });
})();

(function () {
    if (window.__skioBottleBillingApplied) return;
    window.__skioBottleBillingApplied = true;

    function bottlesForPlanName(name) {
        const lower = (name || "").toLowerCase();
        if (lower.includes("6-month") || lower.includes("6 month")) return 6;
        if (lower.includes("3-month") || lower.includes("3 month")) return 3;
        return 1;
    }

    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        if (!picker.shadowRoot || !picker.options?.show_bottle_billing_text) return;
        if (!picker.selectedSellingPlan) return;

        const moneyNoTrailingZeros = (amount) => picker.money(amount).replace(/\.00(?=\D|$)/, "");

        const bottles = bottlesForPlanName(picker.selectedSellingPlan.name);
        const perBottlePrice = picker.price(picker.selectedSellingPlan, false);
        const servings = Number(picker.options?.servings_count) || 12;
        const descText = `${bottles} bottle${bottles === 1 ? "" : "s"}, billed ${moneyNoTrailingZeros(perBottlePrice * bottles)} every ${bottles === 1 ? "month" : bottles + " months"}`;
        const servingText = `${moneyNoTrailingZeros(perBottlePrice / servings)} per serving`;

        picker.shadowRoot.querySelectorAll(".group-topline").forEach(function (topline) {
            let row = topline.querySelector(":scope > .skioBottleBillingRow");
            if (!row) {
                row = document.createElement("div");
                row.className = "skioBottleBillingRow";
                row.style.display = "flex";
                row.style.justifyContent = "space-between";
                row.style.alignItems = "flex-end";
                row.style.paddingBottom = "12px";
                row.style.borderBottom = "1px solid #eadfd6";

                const desc = document.createElement("span");
                desc.className = "skioBottleBillingDesc";
                desc.style.fontFamily = "Figtree, sans-serif";
                desc.style.fontSize = "12px";
                desc.style.fontWeight = "400";
                desc.style.color = "#383838";

                const serving = document.createElement("span");
                serving.className = "skioBottleBillingServing";
                serving.style.fontFamily = "Figtree, sans-serif";
                serving.style.fontSize = "11px";
                serving.style.fontWeight = "600";
                serving.style.textTransform = "uppercase";
                serving.style.color = "#383838";
                serving.style.whiteSpace = "nowrap";

                row.appendChild(desc);
                row.appendChild(serving);
                topline.appendChild(row);
            }

            row.style.gridColumn = "1 / -1";
            row.style.gridRow = "3";

            row.querySelector(".skioBottleBillingDesc").textContent = descText;
            row.querySelector(".skioBottleBillingServing").textContent = servingText;
        });
    });
})();

(function () {
    if (window.__skioRemoveContentIndentApplied) return;
    window.__skioRemoveContentIndentApplied = true;

    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        if (!picker.shadowRoot || !picker.options?.stack_price_under_title) return;

        picker.shadowRoot.querySelectorAll(".group-content.margin-left").forEach(function (content) {
            content.style.marginLeft = "0";
            content.style.marginTop = "20px";
        });

        picker.shadowRoot.querySelectorAll(".selling-plan-dropdown").forEach(function (select) {
            select.style.marginTop = "10px";
            select.style.marginBottom = "20px";
            select.style.height = "43px";
            select.style.padding = "12px 36px 12px 12px";
            select.style.backgroundColor = "transparent";
            select.style.border = "1px solid rgba(84,93,255,.2)";
            select.style.borderRadius = "8px";
            select.style.color = "#383838";
            select.style.fontFamily = "Figtree, sans-serif";
            select.style.fontSize = "14px";
            select.style.fontWeight = "600";
        });
    });
})();

(function () {
    if (window.__skioBestValueBadgeApplied) return;
    window.__skioBestValueBadgeApplied = true;

    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        const container = picker.closest(".productV1SubscribeDetails");
        const badge = container?.querySelector(".skioBestValueBadge");
        if (!badge) return;

        const sellingPlanId = event.detail?.sellingPlan?.id;
        const isVisible = picker.options?.best_value_always_visible
            ? true
            : !!sellingPlanId && String(sellingPlanId) === badge.dataset.bestPlanId;
        badge.classList.toggle("is-visible", isVisible);
    });
})();

(function () {
    if (window.__skioRadioSizeApplied) return;
    window.__skioRadioSizeApplied = true;

    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        if (!picker.shadowRoot) return;

        picker.shadowRoot.querySelectorAll(".skio-radio__container svg").forEach(function (svg) {
            svg.style.width = "20px";
            svg.style.height = "20px";
            svg.setAttribute("viewBox", "0 0 20 20");

            const circles = svg.querySelectorAll("circle");
            const outer = circles[0];
            const inner = circles[1];
            if (outer) {
                outer.setAttribute("cx", "10");
                outer.setAttribute("cy", "10");
                outer.setAttribute("r", "9.5");
            }
            if (inner) {
                inner.setAttribute("cx", "10");
                inner.setAttribute("cy", "10");
                inner.setAttribute("r", "7");
                inner.setAttribute("fill", "none");
                inner.setAttribute("stroke", "currentColor");
                inner.setAttribute("stroke-width", "4");
            }
        });
    });
})();

(function () {
    if (window.__skioGroupTitleFontApplied) return;
    window.__skioGroupTitleFontApplied = true;

    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        if (!picker.shadowRoot) return;

        const { titleFamily, titleSize, titleWeight } = skioGroupTypographyFor(picker);

        picker.shadowRoot.querySelectorAll(".group-title").forEach(function (title) {
            title.style.fontFamily = titleFamily;
            title.style.fontSize = `${titleSize}px`;
            title.style.fontWeight = titleWeight;
        });
    });
})();

(function () {
    if (window.__skioGroupPaddingApplied) return;
    window.__skioGroupPaddingApplied = true;

    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        if (!picker.shadowRoot) return;

        const padding = picker.options?.group_padding;
        if (!padding) return;

        picker.shadowRoot.querySelectorAll(".group-label").forEach(function (label) {
            label.style.padding = padding;
        });
    });
})();

(function () {
    if (window.__skioDiscountGradientApplied) return;
    window.__skioDiscountGradientApplied = true;

    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        if (!picker.shadowRoot) return;

        const gradient = picker.options?.discount_background_gradient;
        if (!gradient) return;

        picker.shadowRoot.querySelectorAll(".savings.bubble").forEach(function (badge) {
            badge.style.backgroundImage = gradient;
            badge.style.display = "inline-flex";
            badge.style.alignItems = "center";
            badge.style.justifyContent = "center";
            badge.style.padding = "2px 8px";
            badge.style.borderRadius = "222px";
            badge.style.border = "none";
            badge.style.fontFamily = "Figtree, sans-serif";
            badge.style.fontSize = "11px";
            badge.style.fontWeight = "800";
            badge.style.lineHeight = "16px";
            badge.style.textTransform = "uppercase";
        });
    });
})();

(function () {
    if (window.__skioFrequencyLabelFontApplied) return;
    window.__skioFrequencyLabelFontApplied = true;

    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        if (!picker.shadowRoot) return;

        const { freqFamily, freqSize, freqColor } = skioGroupTypographyFor(picker);
        if (!freqFamily) return;

        picker.shadowRoot.querySelectorAll(".selling-plan-dropdown-label").forEach(function (label) {
            label.style.fontFamily = freqFamily;
            label.style.fontSize = `${freqSize}px`;
            label.style.color = freqColor;
        });
    });
})();

(function () {
    if (window.__skioBulletsFontApplied) return;
    window.__skioBulletsFontApplied = true;

    document.addEventListener("skio::update-selling-plan", async function (event) {
        const picker = event.target;
        if (!picker.shadowRoot) return;

        const { bulletsFamily: family, bulletsSize: size, bulletsColor: color } = skioGroupTypographyFor(picker);

        if (typeof picker.updateComplete?.then === "function") {
            await picker.updateComplete;
        }

        picker.shadowRoot.querySelectorAll(".skioSubscriptionPerksItem").forEach(function (item) {
            if (family) item.style.fontFamily = family;
            if (size) item.style.fontSize = `${size}px`;
            if (color) item.style.color = color;
        });
    });
})();

(function () {
    if (window.__skioAlwaysShowPerksApplied) return;
    window.__skioAlwaysShowPerksApplied = true;

    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        if (!picker.shadowRoot || !picker.options?.show_perks_when_unselected) return;

        picker.shadowRoot.querySelectorAll(".group-content").forEach(function (content) {
            if (!content.querySelector(".group-content-additional")) return;

            if (picker.options?.selector_type === "hidden") {
                content.style.visibility = "visible";
                content.style.opacity = "1";
                content.style.maxHeight = "none";
            } else {
                content.querySelector(".group-content-additional").style.visibility = "visible";
            }
        });
    });
})();

(function () {
    if (window.__skioInitialSyncApplied) return;
    window.__skioInitialSyncApplied = true;

    const reconciled = new WeakSet();
    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        if (reconciled.has(picker)) return;
        reconciled.add(picker);

        const section = picker.closest("section[id]");
        const otpToggle = section?.querySelector('.productV1SellingLabelInput[value="otp"]');
        if (otpToggle?.checked && typeof picker.selectSellingPlanGroup === "function") {
            picker.selectSellingPlanGroup(null);
        }
    });
})();

(function () {
    if (window.__skioHideProtectLegacyPlanApplied) return;
    window.__skioHideProtectLegacyPlanApplied = true;

    var HIDDEN_PLAN_NAME = "Delivery every 30 days";
    var SCOPED_PRODUCT_HANDLE = "cheers-protect-auto-refill-30-doses-60-capsules";

    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        if (picker.product?.handle !== SCOPED_PRODUCT_HANDLE) return;

        if (picker.selectedSellingPlan?.name === HIDDEN_PLAN_NAME && picker.selectedSellingPlanGroup) {
            const fallback = picker
                .getAvailableSellingPlans(picker.selectedSellingPlanGroup)
                .find(plan => plan.name !== HIDDEN_PLAN_NAME);
            if (fallback) {
                picker.selectSellingPlan(fallback.id);
                return;
            }
        }

        picker.shadowRoot?.querySelectorAll(".selling-plan-dropdown").forEach(function (select) {
            const hiddenOption = Array.from(select.options).find(option => option.textContent.trim() === HIDDEN_PLAN_NAME);
            if (hiddenOption) hiddenOption.remove();
        });
    });
})();

(function () {
    if (window.__skioRestoreDefaultPlanApplied) return;
    window.__skioRestoreDefaultPlanApplied = true;

    const correctedActive = new WeakSet();
    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        const expectedId = picker.dataset?.defaultSubPlanId;
        if (!expectedId) return;

        (picker.availableSellingPlanGroups || []).forEach(function (group) {
            const expectedPlan = picker.getAvailableSellingPlans(group).find(plan => String(plan.id) === String(expectedId));
            if (expectedPlan) group.selected_selling_plan = expectedPlan;
        });

        if (correctedActive.has(picker)) return;
        if (picker.selectedSellingPlan && String(picker.selectedSellingPlan.id) !== String(expectedId)) {
            const group = picker.selectedSellingPlanGroup;
            const expectedPlan = group && picker.getAvailableSellingPlans(group).find(plan => String(plan.id) === String(expectedId));
            if (expectedPlan) {
                correctedActive.add(picker);
                picker.selectSellingPlan(expectedPlan.id);
            }
        }
    });
})();

(function () {
    if (window.__skioHideRestoreDropdownPlanApplied) return;
    window.__skioHideRestoreDropdownPlanApplied = true;

    var HIDDEN_PLAN_NAME = "Delivery every 30 days";
    var SCOPED_PRODUCT_HANDLE = "cheers-restore-auto-refill-12-doses-36-capsules-2";

    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        if (picker.product?.handle !== SCOPED_PRODUCT_HANDLE) return;
        if (picker.options?.selector_type === "hidden") return;

        if (picker.selectedSellingPlan?.name === HIDDEN_PLAN_NAME && picker.selectedSellingPlanGroup) {
            const fallback = picker
                .getAvailableSellingPlans(picker.selectedSellingPlanGroup)
                .find(plan => plan.name !== HIDDEN_PLAN_NAME);
            if (fallback) {
                picker.selectSellingPlan(fallback.id);
                return;
            }
        }

        picker.shadowRoot?.querySelectorAll(".selling-plan-dropdown").forEach(function (select) {
            const hiddenOption = Array.from(select.options).find(option => option.textContent.trim() === HIDDEN_PLAN_NAME);
            if (hiddenOption) hiddenOption.remove();
        });
    });
})();

(function () {
    if (window.__skioAllowedPlanIdsApplied) return;
    window.__skioAllowedPlanIdsApplied = true;

    function parseAllowedPlanIds(picker) {
        const raw = picker.dataset?.allowedPlanIds;
        if (!raw) return null;
        try {
            const ids = JSON.parse(raw);
            if (!Array.isArray(ids) || !ids.length) return null;
            return ids.map(String);
        } catch (e) {
            return null;
        }
    }

    customElements.whenDefined("skio-plan-picker").then(function () {
        const proto = customElements.get("skio-plan-picker").prototype;
        const originalGetAvailableSellingPlans = proto.getAvailableSellingPlans;
        proto.getAvailableSellingPlans = function (group) {
            const plans = originalGetAvailableSellingPlans.call(this, group) || [];
            const allowed = parseAllowedPlanIds(this);
            if (!allowed) return plans;
            return plans.filter(function (plan) {
                return allowed.indexOf(String(plan.id)) !== -1;
            });
        };
    });

    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        const allowed = parseAllowedPlanIds(picker);
        if (!allowed || picker.options?.selector_type === "hidden") return;

        if (picker.selectedSellingPlan && allowed.indexOf(String(picker.selectedSellingPlan.id)) === -1) {
            const fallback = picker.selectedSellingPlanGroup
                ? picker.getAvailableSellingPlans(picker.selectedSellingPlanGroup)[0]
                : null;
            if (fallback) {
                picker.selectSellingPlan(fallback.id);
            }
        }
    });
})();

(function () {
    if (window.__skioFrequencyLabelOverrideApplied) return;
    window.__skioFrequencyLabelOverrideApplied = true;

    document.addEventListener("skio::update-selling-plan", function (event) {
        const picker = event.target;
        if (!picker.shadowRoot) return;

        const raw = picker.dataset.frequencyLabels;
        if (!raw) return;

        let entries;
        try {
            entries = JSON.parse(raw);
        } catch (e) {
            return;
        }
        if (!Array.isArray(entries) || !entries.length) return;

        picker.shadowRoot.querySelectorAll(".selling-plan-dropdown option").forEach(function (option) {
            if (!option.dataset.skioOriginalName) {
                option.dataset.skioOriginalName = option.textContent.trim();
            }
            const original = option.dataset.skioOriginalName;
            const match = entries.find(function (entry) {
                return entry.match && entry.match.trim().toLowerCase() === original.toLowerCase();
            });
            if (match) option.textContent = match.label;
        });
    });
})();

(function () {
    if (window.__skioRealDiscountApplied) return;
    window.__skioRealDiscountApplied = true;

    customElements.whenDefined("skio-plan-picker").then(function () {
        const proto = customElements.get("skio-plan-picker").prototype;
        const originalDiscountText = proto.discountText;
        proto.discountText = function (selling_plan) {
            if (this.options?.selector_type === "hidden") {
                return originalDiscountText.call(this, selling_plan);
            }
            if (!this.options?.discount_text || this.options?.discount_text === "") return;
            if (!selling_plan || !this.selectedVariant?.compare_at_price) {
                return originalDiscountText.call(this, selling_plan);
            }

            const discount = this.discount(selling_plan);
            const chargedPrice = this.selectedVariant.price - discount.amount;
            const compareAtPrice = this.selectedVariant.compare_at_price;
            const realAbsolute = compareAtPrice - chargedPrice;
            const realPercent = Math.round((realAbsolute / compareAtPrice) * 100);
            if (!(realPercent > 0)) return "";

            return this.options.discount_text
                .replaceAll("[discount]", this.options?.discount_format === "absolute" ? this.money(realAbsolute) : realPercent + "%")
                .replaceAll("[future_price_adjustments]", this.postCheckoutDiscountsText(selling_plan) || "");
        };
    });
})();
